(function () {
  function arranca(pista) {
    if (!pista || pista.dataset.f3gListo === '1') return;
    pista.dataset.f3gListo = '1';

    var caja = document.getElementById(pista.getAttribute('data-puntos'));
    var puntos = caja ? [].slice.call(caja.querySelectorAll('.f3g__punto')) : [];
    var total = pista.querySelectorAll('.f3g__item').length;
    if (total < 2) return;

    var movil = window.matchMedia('(max-width: 749px)');
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');
    var solo = pista.getAttribute('data-solo') === '1';
    var espera = parseInt(pista.getAttribute('data-espera'), 10) || 5000;
    var reloj = null;
    var tocado = false;

    function actual() {
      return Math.round(pista.scrollLeft / (pista.clientWidth || 1));
    }
    function pintar() {
      var i = actual();
      for (var n = 0; n < puntos.length; n++) {
        puntos[n].setAttribute('aria-current', n === i ? 'true' : 'false');
      }
    }
    function ir(i) {
      var maximo = pista.scrollWidth - pista.clientWidth;
      var destino = Math.min(i * pista.clientWidth, maximo);
      pista.scrollLeft = destino;
      pintar();
    }
    function parar() {
      if (reloj) {
        window.clearInterval(reloj);
        reloj = null;
      }
    }
    function arrancar() {
      parar();
      if (!solo || tocado || quieto.matches || !movil.matches) return;
      reloj = window.setInterval(function () {
        if (document.hidden) return;
        ir((actual() + 1) % total);
      }, espera);
    }

    if (caja) {
      caja.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.f3g__punto') : null;
        if (!b) return;
        tocado = true;
        parar();
        ir(parseInt(b.getAttribute('data-i'), 10) || 0);
      });
    }
    pista.addEventListener('scroll', function () {
      window.clearTimeout(pista._f3t);
      pista._f3t = window.setTimeout(pintar, 90);
    });
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      pista.addEventListener(ev, function () {
        tocado = true;
        parar();
      }, { passive: true });
    });
    if (movil.addEventListener) {
      movil.addEventListener('change', function () {
        pista.scrollLeft = 0;
        pintar();
        arrancar();
      });
    }
    arrancar();
  }

  function todas() {
    var lista = document.querySelectorAll('.f3g__pista');
    for (var i = 0; i < lista.length; i++) arranca(lista[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todas);
  } else {
    todas();
  }
  document.addEventListener('shopify:section:load', todas);
})();
